/**
 * components/AnnotatedImage.jsx
 * Original Drawing viewer — embeds the ORIGINAL uploaded file (PDF or image)
 * in the browser's native viewer via /api/image/{id}/pdf. The whole document
 * scrolls naturally (all pages), zero server-side page rendering, and the
 * download button hands over the original PDF itself.
 * (Component name kept for backward compatibility with existing imports.)
 */

import React from 'react';
import '../styles/components.css';

function withAuthToken(url) {
  if (!url) return url;
  const jwt = localStorage.getItem('auth_token');
  return jwt ? `${url}?token=${encodeURIComponent(jwt)}` : url;
}

const AnnotatedImage = ({ fileId }) => {
  if (!fileId) {
    return <div style={{ padding: 24, color: '#64748b' }}>No drawing available.</div>;
  }
  const viewUrl = withAuthToken(`/api/image/${fileId}/pdf`);
  const downloadUrl = viewUrl + (viewUrl.includes('?') ? '&' : '?') + 'download=1';

  return (
    <div className="annotated-image-container" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <h3 style={{ margin: 0 }}>Original Drawing</h3>
          <p style={{ margin: '2px 0 0', fontSize: 12, color: '#64748b' }}>
            Scroll to view every page of the original document
          </p>
        </div>
        <a
          href={downloadUrl}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            padding: '7px 14px', borderRadius: 6, background: '#f0f9ff',
            border: '1px solid #bae6fd', color: '#0369a1', fontWeight: 600,
            fontSize: 13, textDecoration: 'none', whiteSpace: 'nowrap',
          }}
        >
          ⬇ Download PDF
        </a>
      </div>
      <iframe
        title="Original drawing"
        src={viewUrl}
        style={{
          width: '100%',
          height: '75vh',
          border: '1px solid #e2e8f0',
          borderRadius: 10,
          background: '#f8fafc',
        }}
      />
    </div>
  );
};

export default AnnotatedImage;
